export const UPLOAD_IMAGE_FORMATS = [ 'jpg', 'jpeg', 'png' ];
